import { render, staticRenderFns } from "./FormTel.vue?vue&type=template&id=467dc1d2&lang=html&"
import script from "./FormTel.vue?vue&type=script&lang=js&"
export * from "./FormTel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports